(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/common/trixa-button.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/common/trixa-button.js');

'use strict';

const Button = svs.ui.ReactButton;
const preventDoubleClick = svs.components.lbUtils.preventDoubleClick;
const TrixaButton = _ref => {
  let isVisible = _ref.isVisible,
    label = _ref.label,
    onClick = _ref.onClick;
  return isVisible ? React.createElement("div", {
    className: "overview-hero-button-container"
  }, React.createElement(Button, {
    "aria-disabled": "true",
    "aria-hidden": "true" 
    ,
    "aria-label": "Trixa g\xE5r bara att spelas med mus.",
    className: "button-200 qa-competition-overview-hero-login-button",
    onClick: preventDoubleClick(onClick)
  }, label)) : null;
};
TrixaButton.defaultProps = {
  label: 'Spela Trixa'
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.common.TrixaButton', TrixaButton);

 })(window);